export function LinkFullSizeOverlay() {
  return (
    <span
      className='absolute opacity-0 w-full h-full z-20 top-0 left-0'
      aria-hidden='true'
      data-role='link-overlay'
    ></span>
  );
}
